export default {
  FAQ: {
    en: "FAQ",
    ja: "よくある質問"
  }
}